<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div v-if="editEnabled">
      <div class="p-2 ml-3 row">
        <div class="col-md-6 border rounded" style="background-color: white;">
          <div class=" p-3 mb-3">
            <h3 class="card-title mb-3">Email Template Design</h3>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label class="form-label">Email Template Name * (required)</label>
                <b-form-input id="userIdControlInput" v-model="selectedTemplate.email_name"
                              class="form-control userInputField"
                              placeholder="Template Name" required
                              type="email"/>
              </div>
              <div class="col-md-6 mb-2">
                <div class="internal d-flex flex-column userInputField ">
                  <label class="form-label" for="internalControlInput">Template Usecase*
                    (required)</label>
                  <select id="mySelect" v-model="selectedTemplate.temp_type"
                          class="py-2 border rounded px-1">
                    <option v-for="(info, index) in emailType" :key="index" :value="info.id">
                      {{ info.email_temp_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-12 mb-2">
                <label class="form-label">Email Subject * (required)</label>
                <input id="userIdControlInput" v-model="selectedTemplate.email_subject"
                       class="form-control userInputField"
                       placeholder="Your Email" type="email"/>
              </div>
            </div>
            <div class="input-group mt-3" title="Using format option">
              <button class="btn btn-primary" type="button"
                      @click="showModal=true">
                Add Image
              </button>
            </div>
            <div class="b-row">
              <div class="b-col" md="4">
                <div class="row">
                  <div class="col-md-9">
                    <div class="row">
                      <div class="col-md-12">
                        <button v-if="main_body_bg_img_id" aria-label="Close"
                                class="btn btn-danger mb-1 mt-3" style="padding: 0%;" type="button"
                                @click="main_body_bg_img_path = null, main_body_bg_img_id = null">
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                    </div>
                    <figure v-if="selectedTemplate.logo" class="figure"
                            style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
                      <div v-if="selectedTemplate.logo">
                        <img :src="selectedTemplate.logo" alt="media" class="img-thumbnail"
                             style="display:flex;justify-content: center;align-items: center; min-height: 100px;max-height: 130px;
                             max-width: 60%;object-fit: contain; background-color: rgb(244, 245, 245);border-radius: 6px;">
                      </div>
                    </figure>
                  </div>
                </div>
              </div>
              <div class="b-col" md="4">
                <div class=" mx-2">
                  <div class="row mb-1">
                    <div class="col-md-6 card-title" style="font-size: 16px; font-weight: 500;">
                      Email Header Color
                    </div>
                    <div class="col-md-1 d-none d-sm-block">:</div>
                    <div class="col-md-2 card-text">
                      <div class="input-group" title="Using format option">
                        <input v-model="selectedTemplate.head_back_color"
                               class="form-control input-lg" type="color"/>
                      </div>
                    </div>
                    <div class="col-md-3 card-text">
                      <div class="input-group" title="Using format option">
                        <input v-model="selectedTemplate.head_back_color"
                               class="form-control input-lg" type="text"/>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-md-6 card-title" style="font-size: 16px; font-weight: 500;">
                      Email Body Text Size
                    </div>
                    <div class="col-md-1 d-none d-sm-block">:</div>
                    <div class="col-md-2 card-text">
                      <div class="input-group" title="Using format option">
                        <input v-model="selectedTemplate.text_size" class="form-control input-lg"
                               type="number"/>
                      </div>
                    </div>
                    <div class="col-md-3 card-text">
                      <div class="input-group" title="Using format option">
                        <input v-model="selectedTemplate.text_size"
                               class="form-range form-control input-group" max="1000" min="0" step="1"
                               type="range"/>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1">
                    <div class="col-md-6 card-title" style="font-size: 16px; font-weight: 500;">
                      Email Footer Background
                      Color
                    </div>
                    <div class="col-md-1 d-none d-sm-block">:</div>
                    <div class="col-md-2 card-text">
                      <div class="input-group" title="Using format option">
                        <input v-model="selectedTemplate.foot_back_color"
                               class="form-control input-lg" type="color"/>
                      </div>
                    </div>
                    <div class="col-md-3 card-text">
                      <div class="input-group" title="Using format option">
                        <input v-model="selectedTemplate.foot_back_color"
                               class="form-control input-lg" type="text"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group mt-3">
              <label for="exampleFormControlTextarea1">Email Content Text :</label>
              <Editor :htmlFetch="selectedTemplate.body_content" @htmlData='getEnglishHtmlContent'></Editor>
              <!--<textarea class="form-control" v-model="selectedTemplate.body_content" style="width: 100%"
                  id="exampleFormControlTextarea1" rows="3"></textarea>-->
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="border rounded" style="background-color: white;">
            <div class="row ">
              <h3 class="card-title pl-5 pt-3 mb-3">Email Template Design Preview</h3>
              <div class="col-md-12">
                <html xmlns="http://www.w3.org/1999/xhtml">

                <head>
                  <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
                  <title>CMS Reset Password</title>
                </head>

                <body>
                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td align="center" valign="top"><br> <br>
                      <table border="1px" cellpadding="0" cellspacing="0" width="80%">
                        <tr>
                          <td :style="{ backgroundColor: selectedTemplate.head_back_color, fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '13px', color: '#000000', padding: '10px 0px' }"
                              bgcolor="#21213c" valign="top">
                            <div style="font-size: 20px; color:white;">
                              <img :src="selectedTemplate.logo" alt="Idra Logo"
                                   style="background-color: white; width: 8%; border-radius: 12px; margin-left: 2%;">
                              <span style="margin-left: 16px;">{{ company_name }}</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-family: Arial, Helvetica, sans-serif; font-size: 5px; color: #000000; padding: 10px 15px;"
                              valign="top">
                            <div :style="{ fontSize: `${selectedTemplate.text_size}px`, color: 'black' }"
                                 v-html="selectedTemplate.body_content">
                            </div>
                          </td>
                        </tr>
                        <td :style="{ backgroundColor: selectedTemplate.foot_back_color, fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '13px', color: '#000000', padding: '10px 15px 10px 15px' }"
                            align="center" valign="top">
                          <div style="font-size: 24px; color:white;margin-bottom: 40px;">
                            <span>Get in Touch</span>
                          </div>
                          <div style="font-size: 16px; color:white;">
                            <span>This email was sent by : {{ company_mail }}</span>
                          </div>
                          <div style="font-size: 16px; color:white; margin-bottom: 40px;">
                                                            <span>For any question send an email to {{
                                                                company_mail
                                                              }}</span>
                          </div>
                          <div style="font-size: 18px; color:white;">
                            <span>Privacy policy | Help</span>
                          </div>
                        </td>
                      </table>
                      <br> <br>
                    </td>
                  </tr>
                </table>
                </body>

                </html>
              </div>
              <div v-if="showModal">
                <div id="exampleModal" aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade show"
                     role="dialog" style="display: block;" tabindex="-1">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 id="exampleModalLabel" class="modal-title"><b>Add Image to Email</b>
                        </h5>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                                type="button" @click="showModal = false"></button>
                      </div>
                      <div class="modal-body">
                        <div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="row">
                                <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                                  <select-logo :fetchPath="selectedImagePath"
                                               @logoImg="setImage"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-primary" type="button" @click="showModal = false">Save
                          Images
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-12 d-flex justify-content-end my-3">
          <button v-if="updateForm == null" class=" btn btn-primary me-2 " @click="saveTypography()">
            Save
          </button>
          <button v-if="updateForm != null" class=" btn btn-primary me-2 " @click="updateTemp()">
            Update
          </button>
          <button class=" btn btn-danger" @click="resetVariable()">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <button v-if="addNewShowBtn" class="btn btn-primary mb-2" @click="newAlbum()">Add New Template</button>
    <div class="rounded border p-3 bg-white">
      <b-row class="mt-2">
        <b-col class="col-4 p-1" lg="3" md="4">
          <b-form-group class="ms-2">
            <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" class="col-md-4"
                           size="sm"></b-form-select>
          </b-form-group>
        </b-col>
        <!-- search  -->
        <b-col>
          <div class="d-flex flex-row">
            <b-form-input v-model="filter" :formatter="searchFormatter" class="me-2"
                          placeholder="Type to filter data" type="search"></b-form-input>
            <button class="rounded btn-info me-4" @click="onSearch">
              Search
            </button>
          </div>
        </b-col>
      </b-row>
      <b-table :busy="loading" :current-page="currentPage" :fields="fields" :items="emailTemplatesResponse"
               :per-page="perPage" bordered hover responsive striped>
        <template #cell(logo)="row">
          <figure v-if="row.item.logo" class="figure"
                  style=" margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
            <div v-if="row.item.logo">
              <img :src="row.item.logo" alt="media" class="img-thumbnail"
                   style="height: 100px; width: 100px; object-fit: cover; display:flex;justify-content: center;align-items: center; background-color: rgb(244, 245, 245);border-radius: 6px;">
            </div>
          </figure>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex gap-1 justify-content-center">
            <button class="btn btn-info btn-sm" type="button" @click="enableEdit(row.item)">
              <i class="fa-regular fa-pen-to-square"></i>
            </button>
          </div>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2 px-2">
            <b-spinner class="align-middle mx-2"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <!-- Pagination -->
      <b-row>
        <b-col class="mt-2" md="12" sm="12">
          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center"
                        class="my-0" next-text="Next" prev-text="Prev" @click="handlePageChange"></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ThemeTypographyService from "@/services/theme-typography.service";
import selectLogo from '@/components/Media/SelectLogo.vue';
import Config from '@/config/index';
import {email} from "@vuelidate/validators";
import Editor from "../../components/Editor";

export default {
  name: "EmailTemplate",
  components: {
    Editor,
    "select-logo": selectLogo,
  },
  computed: {
    email() {
      return email;
    },
    selectedImagePath() {
      return this.selectedTemplate.logo;
    }
  },
  mounted() {
  },


  data() {
    return {
      loading: false,
      showModal: false,
      editEnabled: false,
      main_body_bg_img_id: null,
      main_body_bg_img_path: null,
      emailTemplatesResponse: [],
      emailType: [],
      fields: [
        {
          key: "email_name",
          label: "Name",
          sortable: false,
          class: "text-center",
          filterByFormatted: true,
        },
        {
          key: "email_subject",
          label: "Subject",
          sortable: false,
          class: "text-center",
          filterByFormatted: true,
        },
        {
          label: "Header Color",
          key: "head_back_color",
          tdClass: "px-3",
          thClass: "px-3",
        },
        {
          label: "Footer Color",
          key: "foot_back_color",
          tdClass: "px-3",
          thClass: "px-3",
        },
        {
          key: "text_size",
          sortable: true,
          tdClass: "px-3",
          thClass: "px-3",
          formatter: (value) => {
            return value + "px";
          },
        },
        {
          key: "logo",
          label: "Logo",
          sortable: false,
          class: "text-center",
          filterByFormatted: true,
        },

        {
          key: "actions",
          label: "Actions",
          class: "text-center",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 100],
      filter: "",
      backupAllTemplates: null,
      selectedTemplate: null,
      addNewShowBtn: true,
      updateForm: null,
      itemsBread: [
        {
          text: "Home",
          to: "/dashboard",
        },
        {
          text: "Theme Options",
          to: "/portal-header",
        },
        {
          text: "Email Templates",
          href: "#",
        },
      ],
    };
  },
  created() {
    this.getAllEmailTemplates();
    this.fetchEmailType();
  },
  methods: {
    getEnglishHtmlContent(data) {
      this.selectedTemplate.body_content = data;
    },
    async fetchEmailType() {
      const response = await ThemeTypographyService.getEmailType();
      if (response.data) {
        this.emailType = response.data;
      }

    },

    setImage(data) {
      this.selectedTemplate.logo = Config.apiFileBasePath + data.file_path;
    },
    async saveTypography() {
      const response = await ThemeTypographyService.saveEmailTemplate(this.selectedTemplate);
      if (response.data) {
        this.showNotification('success', response.data.message);
        await this.getAllEmailTemplates();
      } else {
        this.showNotification('error', response.data.message);
        await this.getAllEmailTemplates();
      }
    },
    async updateTemp() {
      const response = await ThemeTypographyService.updateEmailTemplate(this.selectedTemplate);
      if (response.data) {
        this.showNotification('success', response.data.message);
        await this.getAllEmailTemplates();
        this.editEnabled = false;
        this.selectedTemplate = null;
      } else {
        this.showNotification('error', response.data.message);
        // await this.getAllEmailTemplates();
      }
    },
    resetVariable() {
      this.editEnabled = false;
      this.selectedTemplate = null;
      this.addNewShowBtn = true
      this.updateForm = null;
      this.getAllEmailTemplates();
    },
    newAlbum() {
      this.selectedTemplate = null;
      this.addNewShowBtn = false;
      this.getEmailThemeProperty();
      this.editEnabled = true;
    },
    getHtmlContent(data) {
      this.selectedTemplate.body_content = data;
    },
    enableEdit(data) {
      this.editEnabled = false;
      this.selectedTemplate = null;
      this.updateForm = data.id;
      this.editEnabled = true;
      this.selectedTemplate = {...data};
    },
    async getEmailThemeProperty() {
      const response = await ThemeTypographyService.getEmailThemeProperty(24031013040355);
      if (response.data) {
        this.selectedTemplate = response.data;
        this.main_body_bg_img_path = response.data.logo;
        this.body_layout_size = response.data.text_size;
        this.header_bg_color = response.data.head_back_color;
        this.footer_bg_color = response.data.foot_back_color;
        this.imageUrl = response.data.logo;
      }
    },
    searchFormatter(data) {
      this.filter = data;
      if (this.filter != null && this.filter != "") {
        this.emailTemplatesResponse = [];
        this.backupAllTemplates.forEach((template) => {
          if (template.email_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.emailTemplatesResponse.push(template);
          } else if (template.email_subject.toLowerCase().includes(this.filter.toLowerCase())) {
            this.emailTemplatesResponse.push(template);
          }
        });
      } else {
        this.emailTemplatesResponse = this.backupAllTemplates;
      }
      this.totalRows = this.emailTemplatesResponse.length;
      this.currentPage = 1;
      return data;
    },
    onSearch() {
      if (this.filter != null && this.filter != "") {
        this.emailTemplatesResponse = [];
        // this.backupAllTemplates.forEach(user => {
        //   if (user.user_name.toLowerCase().includes(this.filter.toLowerCase())) {
        //     this.allUsers.push(user);
        //   }
        // });
      } else {
        this.emailTemplatesResponse = this.backupAllTemplates;
      }
      this.totalRows = this.emailTemplatesResponse.length;
      this.currentPage = 1;
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: "Footer",
        text: message,
      });
    },
    async getAllEmailTemplates() {
      try {
        this.loading = true;
        const response = await ThemeTypographyService.getAllEmailTemplates();
        this.loading = false;

        if (response.data) {
          this.emailTemplatesResponse = response.data;
          this.loading = false;
          this.backupAllTemplates = this.emailTemplatesResponse;
          this.totalRows = this.emailTemplatesResponse.length;
        } else {
          this.showNotification("error", "Could not get templates");
        }
      } catch (e) {
        this.loading = false;
        this.showNotification("error", "Could not get templates");
      }
    },
  },
};
</script>
